import { APP_SECRET } from "@/api/secret";
import { param } from "jquery";
import Vue from "vue";
import { CATEGORY_ROUTES, DIAGNOSTIC_ROUTES, GOAL_ROUTES } from "../api/routes";

export const namespaced = true;
export const state = () => ({
  goals: [],
  isLoading: false,
  testing: "Hello world",
  // TODO GET DATA DYBAMICALLY
  categories: [],
  questions: [
    {
      id: 1,
      label:
        "Voulez-vous intégrer notre panel de testeuses et partager votre avis sur notre blog et sur les réseaux sociaux ?",
    },
    {
      id: 2,
      label:
        "Aimeriez-vous découvrir de nouveaux produits et de nouvelles marques lors d’animations découvertes dans nos instituts ? ",
    },
    {
      id: 3,
      label:
        "Souhaiteriez-vous faire partie de la communauté Blinki et partager votre expérience sur le dossier esthétique ? ",
    },
  ],
  error: null,
  currentDiag: {
    objectif_id: "",
    objectif_name: "",
    prescriptions: [],
    subcategory_id: null,
    diag_type_id: null,
    comment: "",
    selectedSubCategory_IDs: [],
    isEdit: false,
    title: "",
    replies: [],
  },
  currentObj: {
    title: null,
    description: null,
    categorie_id: null,
    sous_categorie_id: null,
  },
});

export const getters = {
  isLoading: (state) => {
    return state.isLoading;
  },
  selectedObjectif: (state) => {
    return state.currentObj;
  },
  clientGoals: (state) => {
    return state.goals;
  },
  categories: (state) => {
    return state.categories;
  },
  objectif_name: (state) => {
    return state.currentDiag.objectif_name;
  },
  objectif_id: (state) => {
    return state.currentDiag.objectif_id;
  },
  prescriptions: (state) => {
    return state.currentDiag.prescriptions;
  },
  selectedSubCategory_IDs: (state) => {
    return state.currentDiag.selectedSubCategory_IDs;
  },
  comment: (state) => {
    return state.currentDiag.comment;
  },
  isEdit: (state) => {
    return state.currentDiag.isEdit;
  },
  title: (state) => {
    return state.currentDiag.title;
  },
  questions: (state) => {
    return state.questions;
  },
  replies: (state) => {
    return state.replies;
  },
};

export const mutations = {
  SELECTED_TITLE(state, title) {
    if (!state.currentDiag.title.includes(title)) {
      state.currentDiag.title+=title+',';
    }else{
    state.currentDiag.title=state.currentDiag.title.replaceAll(title+',', '');
    }
  },
  SELECTED_COMMENT(state, comment) {
    if (state.currentDiag.comment !== comment) {
      state.currentDiag.comment = comment;
    }
  },
  SELECTED_CATEGORIE(state, params) {
    state.currentObj.categorie_id = params.categorie_id;
    state.currentObj.sous_categorie_id = params.sous_categorie_id;
  },
  SELECTED_DESCRIPTION(state, description) {
    if (state.currentObj.description !== description) {
      state.currentObj.description = description;
    }
  },
  GOALS_SUCCESS(state, params) {
    state.goals = params;
  },
  SET_IS_LOADING(state, params) {
    state.isLoading = params;
  },
  CATEGORIES_SUCCESS(state, params) {
    state.categories = params;
  },
  SET_OBJECTIF(state, params) {
    state.currentDiag.objectif_name = params.objectif_name;
    state.currentDiag.objectif_id = params.objectif_id;
  },
  SET_CURRENT_DIAG(state, params) {
    state.currentDiag = params;
  },
  SET_NEW_PRESCRIPTION(state, params) {
    state.currentDiag.prescriptions.push(params);
  },
  REMOVE_PRESCRIPTION(state, params) {
    state.currentDiag.prescriptions = state.currentDiag.prescriptions.filter(
      (item) => item.article_id != params
    );
  },
  SET_SUB_CATEGORY_IDS(state, params) {
    if (state.currentDiag.selectedSubCategory_IDs.indexOf(params) === -1) {
      state.currentDiag.selectedSubCategory_IDs.push(params);
    } else {
      state.currentDiag.selectedSubCategory_IDs =
        state.currentDiag.selectedSubCategory_IDs.filter(
          (item) => item != params
        );
    }
  },
  SET_REPLY(state, param) {
    state.replies = state.replies.map((item) => {
      if (item.id == param.id) {
        item.reply = param.reply;
        return item;
      }
      return item;
    });
  },
};

export const actions = {
  async getObjectifs({ commit }) {
    commit("SET_IS_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$api
        .request(goalsRoutes.getGoals)
        .then((response) => {
          commit("GOALS_SUCCESS", response.payload);
          commit("SET_IS_LOADING", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_IS_LOADING", false);
          reject(error);
        })
        .finally(() => {});
    });
  },

  async addObjectif({ commit, state }, data) {
    commit("SET_IS_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$api
        .request(GOAL_ROUTES.createGoal, {}, data)
        .then((response) => {
          if (response._response.code === "GL200_01") {
            Vue.$toast.open({
              message: response._response.message,
              type: "success",
            });
            resolve(response.payload);
          } else {
            Vue.$toast.open({
              message: response._response.message,
              type: "error",
            });
          }
          commit("SET_IS_LOADING", false);
        })
        .catch((err) => {
          reject(err);
          commit("SET_IS_LOADING", false);
        })
        .finally(() => {});
    });
  },
  async addDiagnostic({ commit, state }, data) {
    commit("SET_IS_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$api
        .request(DIAGNOSTIC_ROUTES.createDiagnostic, {}, data)
        .then((response) => {
          if (response._response.code === "DGT200_01") {
            Vue.$toast.open({
              message: response._response.message,
              type: "success",
            });
            resolve();
          } else {
            Vue.$toast.open({
              message: response._response.message,
              type: "error",
            });
          }
          commit("SET_IS_LOADING", false);
        })
        .catch((err) => {
          reject(err);
          commit("SET_IS_LOADING", false);
        })
        .finally(() => {});
    });
  },
  async getCategories({ commit }) {
    commit("SET_IS_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$api
        .request(CATEGORY_ROUTES.list)
        .then((response) => {
          const categories = response.payload.filter(
            (item) => item.sous_categories.length > 0
          );
          commit("CATEGORIES_SUCCESS", categories);
          commit("SET_IS_LOADING", false);
          resolve();
        })
        .catch((error) => {
          commit("SET_IS_LOADING", false);
          reject(error);
        })
        .finally(() => {});
    });
  },
  async setTitleAndCategorie({ commit }, params) {
    const { title, ...rest } = params;
    commit("SELECTED_TITLE", title);
    commit("SELECTED_CATEGORIE", rest);
  },

  async setIsLoading({ commit }, params) {
    commit("SET_IS_LOADING", params);
  },
};
